<template>
	<div id="app">
		<!-- 头部 -->
		<HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
		<HeaderView @serchMsg="serchParams"></HeaderView>
		<NavView></NavView>
		<!-- 内容 -->
		<div class="content">
			<section class="banner_div word">
				<div class="page">
					<div class="page-line" v-for="(item,index) in data" :key="index" @click="detail(item.nid)">
						<div class="imgbox">
							<img :src="item.imageUrl" alt="图" />
						</div>
						<div class="msg">
							<h3 class="title">{{item.title}}</h3>
							<div>
								<h4 class="font1">{{item.viceTitle}}</h4>
							</div>
							<i class="line"></i>
							<div class="timer">{{item.createTime}}</div>
						</div>
					</div>
				</div>

				<el-pagination background layout=" pager" :page-size="pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				 :total="totleNum"></el-pagination>
			</section>
		</div>
		<!-- 底部 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import HeaderView from "@/components/assembly/Header.vue"; //头部模块
	import NavView from "@/components/assembly/Nav.vue"; //导航模块
	import Footer from "@/components/assembly/Footer.vue"; //导航模块
	export default {
		name: "News",
		data() {
			return {
				num: "1",
				pageNum: 1, //页码
				pageSize: 4, //每页多少条
				data: [], //页面数据
				totleNum: 1,
				serchData: '',
				serchContent: false, //显示搜索的文章内容，false为默认的文章内容
			};
		},
		created() {
			this.getMsg()
		},
		watch: {
			serchData(now, pre) {
				if (now == '') {
					this.serchContent = false
				} else {
					this.serchContent = true
				}
			}
		},
		methods: {
			handleSizeChange(val) {
				this.pageSize = val;
			},
			handleCurrentChange(val) {
				this.pageNum = val;
			},
			//获取新闻
			getMsg() {
				let url = "/open/news/information/list";
				let data = {
					contentType: 1, //1资讯 2案例
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					keyWord: this.serchData
				};
				this.$get(url, data).then(res => {
					this.data = res.data
					this.totleNum = res.params.totalDataCounts
				});
			},
			serchParams(prop) {
				this.serchData = prop
				this.getMsg()
			},
			detail(nid) {
				this.$router.push({
					path: '/newsDetail',
					query: {
						nid: nid
					}
				});
			}
		},
		components: {
			HeaderView,
			NavView,
			HeaderTopView,
			Footer
		}
	};
</script>

<style scoped>
	.content {
		padding: 64px 0 48px 0;
	}

	.page {
		margin-bottom: 48px;
	}

	.page-line {
		display: flex;
		margin-top: 70px;
	}

	.page-line:first-child {
		margin-top: 0;
	}

	.imgbox {
		width: 382px;
		height: 262px;
		margin-right: 54px;
	}

	img {
		width: 100%;
		height: 100%;
	}

	.msg {
		width: 766px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.title {
		color: #1a1a1a;
		font-size: 22px;
		text-align: left;
	}

	.font1 {
		font-size: 16px;
		color: #4a4a4a;
		margin: 27px 0 36px 0;
		text-align: left;
	}

	.font1>p>img {
		width: 30px !important;
	}

	.line {
		display: block;
		width: 144px;
		height: 2px;
		background: #000000;
	}

	.timer {
		font-size: 20px;
		color: #333;
		text-align: left;
		margin-top: 23px;
	}
</style>



// WEBPACK FOOTER //
// src/components/news/News.vue